/**
 * Priority order used by customer-facing booking lists.
 * AWAITING_PAYMENT is intentionally first — the customer has a payment
 * deadline on these bookings, so we surface them above everything else
 * to reduce drop-off. Other live statuses follow; cancelled/expired sink
 * to the bottom. Unknown statuses get a neutral mid-range priority.
 */
const STATUS_PRIORITY = {
  AWAITING_PAYMENT: 1,
  PENDING_ALLOCATION: 2,
  CONFIRMED: 3,
  COMPLETED: 4,
  CANCELLED: 5,
  RELEASED: 5,
  EXPIRED: 5,
  NO_SHOW: 5,
};

const FALLBACK_PRIORITY = 4;

/**
 * Sort bookings by (status priority ASC, created_at DESC).
 * Pure function — does not mutate the input array.
 */
export function sortBookingsByPriority(bookings) {
  if (!Array.isArray(bookings)) return [];
  return [...bookings].sort((a, b) => {
    const pa = STATUS_PRIORITY[a?.status] ?? FALLBACK_PRIORITY;
    const pb = STATUS_PRIORITY[b?.status] ?? FALLBACK_PRIORITY;
    if (pa !== pb) return pa - pb;
    // Same bucket → newer-first
    const ca = a?.created_at || '';
    const cb = b?.created_at || '';
    if (ca === cb) return 0;
    return ca < cb ? 1 : -1;
  });
}

export default sortBookingsByPriority;
